import type { ExtractPropTypes } from 'vue'
import { radioProps, radioEmits } from './radio'

export const radioButtonProps = {
  ...radioProps,
  /**
   * 单选框的值
   */
  label: {
    type: [String, Number, Boolean],
    default: ''
  }
} as const

export const radioButtonEmits = radioEmits

export type RadioButtonProps = ExtractPropTypes<typeof radioButtonProps>
export type RadioButtonEmits = typeof radioButtonEmits